let filterItemsTitle = document.getElementsByClassName('filter-group-summary');
let filterItems = document.getElementsByClassName('filter-group');
let filterSortItems = document.getElementsByClassName('filter-group-display__list-item');

/**
 * Function for add/remove class for active open filter category
 * @param thisElement
 * @param thisIndex
 */
function activeTab(thisElement, thisIndex) {
    //console.log("clog:", thisElement)
    Array.from(filterItems).forEach((element, index) => {
        if(thisIndex === index) {
            console.log("ADD", index)
            if (element.classList.contains("active")) {
                element.classList.remove("active");
            } else {
                element.classList.add("active");
            }
        } else {
            console.log("REMOVE", index)
            element.classList.remove("active");
        }
    });
}

/**
 * Add onclick trigger to filter categories
 * Sort By: ?sort_by=manual (featured) | ?sort_by=best-selling | title-ascending (Alphabet A-Z) | title-descending (Alphabet Z-A) |
 * price-ascending (LOW > HIGH) | price-descending (HIGH > LOW) | created-ascending (DATE OLD > NEW) | created-descending (DATE NEW > OLD)
 */
Array.from(filterItemsTitle).forEach((element, index, elements) => {
    element.onclick = (element) => {
        activeTab(element, index)
    }
});

/**
 * Function for add/remove class for active open filter category
 */
function triggerSort(thisElement, thisIndex) {
    Array.from(filterSortItems).forEach((element, index) => {
        if(thisIndex === index) {
            console.log("SORT BY", index, element)
        } else {
            //console.log("NOT SORT BY", index)
        }
    });
}

/**
 * Add onclick trigger to sort categories
 */
Array.from(filterSortItems).forEach((element, index, elements) => {
    element.onclick = (element) => {
        triggerSort(element, index)
    }
});
